(function () {
  "use strict";

  angular.module("sempraWebapp").component("tokenPackages", {
    templateUrl: "app/pricing/tokenPackages/tokenPackages.component.html",
    controller: tokenPackagesController,
    bindings: {
      tokenPackageData: "<",
      regionCurrency: "<",
      onCreate: "&"
    },
    controllerAs: "vm"
  });

  function tokenPackagesController(pricingActions, $translate, $scope) {
    var vm = this;

    $scope.saveButtonClass = "md-primary";

    vm.tokenPackagesData = {};
    vm.tokenPackageList = [];
    vm.editTokenPackages = false;
    vm.deleteTokenPackages = false;
    vm.buttonTitle = $translate.instant("SAVE");

    vm.$onChanges = function (changes) {
      if (changes.tokenPackageData) {
        vm.tokenPackageList = changes.tokenPackageData.currentValue;
      } else if (changes.regionCurrency) {
        vm.regionCurrency = changes.regionCurrency.currentValue;
      } else {
        return;
      }
    };

    vm.save = function (tokenPackageData) {
      var data = {
        id: tokenPackageData.id,
        name: tokenPackageData.name,
        tokenAmount: tokenPackageData.tokenAmount,
        priceAmount: tokenPackageData.priceAmount,
        validity: tokenPackageData.validity
      };
      if (vm.editTokenPackages) {
        updateTokenPackageData(data);
      } else if (vm.deleteTokenPackages) {
        deleteTokenPackageData(data);
      } else {
        saveTokenPackageData(data);
      }
    };

    vm.editPackage = function (tokenPackage) {
      vm.tokenPackagesData = {
        id: tokenPackage.id,
        name: tokenPackage.name,
        tokenAmount: tokenPackage.tokens.amount,
        priceAmount: tokenPackage.price.amount,
        validity: tokenPackage.validity
      };
      vm.buttonTitle = $translate.instant("UPDATE");
      vm.editTokenPackages = true;
    };

    vm.deletePackage = function (tokenPackage) {
      $scope.saveButtonClass = "custom-save-button-class";
      vm.tokenPackagesData = {
        id: tokenPackage.id,
        name: tokenPackage.name,
        tokenAmount: tokenPackage.tokens.amount,
        priceAmount: tokenPackage.price.amount,
        validity: tokenPackage.validity
      };
      vm.buttonTitle = $translate.instant("DELETE");
      vm.editTokenPackages = false;
      vm.deleteTokenPackages = true;
    };

    vm.cancel = function () {
      vm.tokenPackagesData = {
        id: null,
        name: null,
        tokenAmount: null,
        priceAmount: null,
        validity: null
      };
      vm.buttonTitle = $translate.instant("SAVE");
      vm.editTokenPackages = false;
      vm.deleteTokenPackages = false;
      $scope.tokenPackageForm.$setUntouched();
      $scope.saveButtonClass = "md-primary";
    };

    function saveTokenPackageData(data) {
      pricingActions.createCompanyTokenPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function updateTokenPackageData(data) {
      pricingActions.updateCompanyTokenPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function deleteTokenPackageData(data) {
      pricingActions.deleteCompanyTokenPackage(data.id).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }
  }
})();
